<template>
  <validation-observer ref="tabIv">
    <custom-collapse class="mt-2" :id="'tab-' + skill.id">
      <custom-collapse-item
        :title="skill.name"
        :parentId="'tab-' + skill.id"
        :expanded="skill.expanded"
        :checked="skill.checked"
        :selected="skill.selected"
        :disabled="isReadOnly"
        :buttonIcon="'far fa-times-circle color-red'"
        :expanded-icon="'fas fa-plus-circle color-black--3'"
        @actionButtonClick="onDeleteClicked"
        @expandButtonClick="expandButtonClicked"
      >
        <div class="row">
          <div class="col-12 px-4">
            <validation-provider :rules="'required'" v-slot="{ errors }">
              <item-skills
                :questionnaire="questionnaire"
                :is-read-only="isReadOnly"
                :title="skill.name"
                :skill-id="skill.id"
                v-model="model"
              />
            </validation-provider>
          </div>
        </div>
      </custom-collapse-item>
    </custom-collapse>
  </validation-observer>
</template>
<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import referralAndEquipmentsService from '@/services/api/referralsandequipments.api';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import mixAlert from '@/mixins/alert.mixin';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import referralsAndEquipmentSkills from '@/utils/constants/referralsAndEquipmentSkills';
import ItemSkills from './ItemSkills.vue';

export default {
  name: 'SkillRow',
  components: {
    SectionTitle,
    CustomDropDown,
    ActionButton,
    CustomCollapse,
    CustomCollapseItem,
    ValidationObserver,
    ValidationProvider,
    CustomInput,
    ItemSkills,
  },
  mixins: [mixAlert],
  props: {
    value: {
      type: Object,
      default: () => ({
        questions: [],
        additionalRemarks: {
          comuniAdditionalObservation: null,
          importObservations: null,
          resultOfEvaluationAudiological: null,
          ophthalmologicEvaluation: null,
          cognitiveAdditionalObservation: null,
          wordsPerMinutes: null,
          lectureAdditionalObservation: null,
          motoAdditionalObservation: null,
          mathAdditionalObservation: null,
          writeAdditionalObservation: null,
        },
      }),
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    skill: {
      type: Object,
      default: {},
    },
    atServiceId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      questionnaire: [],
    };
  },
  created() {
    this.getSection();
  },
  methods: {
    async onDeleteClicked() {
      var deleteWithoutAlert = true;
      this.questionnaire.forEach((element) => {
        element.questions.forEach((question) => {
          question.answers.forEach((answer) => {
            if (answer.isSelected == true) {
              deleteWithoutAlert = false;
            }
          });
        });
      });

      deleteWithoutAlert =
        this.value.questions.filter((x) => x.skillId == this.skill.id).length ==
        0;

      if (this.skill.id == referralsAndEquipmentSkills.SensorySkills) {
        deleteWithoutAlert =
          deleteWithoutAlert &&
          this.value.additionalRemarks.importObservations == null &&
          this.value.additionalRemarks.resultOfEvaluationAudiological == null &&
          this.value.additionalRemarks.ophthalmologicEvaluation == null &&
          this.value.additionalRemarks.ophthalmologicEvaluation == null;
      }

      if (this.skill.id == referralsAndEquipmentSkills.CommunicationSkills) {
        deleteWithoutAlert =
          deleteWithoutAlert &&
          this.value.additionalRemarks.comuniAdditionalObservation == null;
      }

      if (this.skill.id == referralsAndEquipmentSkills.CognitiveSkills) {
        deleteWithoutAlert =
          deleteWithoutAlert &&
          this.value.additionalRemarks.cognitiveAdditionalObservation == null;
      }

      if (this.skill.id == referralsAndEquipmentSkills.ReadingSkills) {
        deleteWithoutAlert =
          deleteWithoutAlert &&
          this.value.additionalRemarks.lectureAdditionalObservation == null &&
          this.value.additionalRemarks.wordsPerMinutes == null;
      }

      if (this.skill.id == referralsAndEquipmentSkills.MotorSkills) {
        deleteWithoutAlert =
          deleteWithoutAlert &&
          this.value.additionalRemarks.motoAdditionalObservation == null;
      }

      if (this.skill.id == referralsAndEquipmentSkills.MathematicsSkills) {
        deleteWithoutAlert =
          deleteWithoutAlert &&
          this.value.additionalRemarks.mathAdditionalObservation == null;
      }

      if (this.skill.id == referralsAndEquipmentSkills.WritingSkills) {
        deleteWithoutAlert =
          deleteWithoutAlert &&
          this.value.additionalRemarks.writeAdditionalObservation == null;
      }
      if (this.skill.id == referralsAndEquipmentSkills.SelfCareSkills) {
        deleteWithoutAlert =
          deleteWithoutAlert &&
          this.value.additionalRemarks.ownCareAdditionalObservation == null;
      }

      if (deleteWithoutAlert) {
        this.$emit('delete', {
          skill: this.skill,
          questionnaire: this.questionnaire,
        });
        return false;
      }
      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover el panel de ${this.skill.name}, se eliminarán los datos suministrados hasta ahora?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) {
        return;
      }

      this.$emit('delete', {
        skill: this.skill,
        questionnaire: this.questionnaire,
      });
    },
    expandButtonClicked() {
      this.skill.expanded = !this.skill.expanded;
    },
    async getSection() {
      if (!this.atServiceId || !this.skill.id) return;
      var { data } = await referralAndEquipmentsService.getSkillQuestionnaire(
        this.atServiceId,
        this.skill.id
      );
      this.questionnaire = data;
      this.model.questions.push(...this.getAnswers());
    },
    getAnswers() {
      const questionAnswers = this.questionnaire
        .map((x) => x.questions)
        .flat()
        .map((x) => ({
          questionId: x.id,
          text: x.text,
          answers: x.answers.filter((a) => a.isSelected).map((a) => a.id),
        }));

      return questionAnswers
        .map((x) => {
          return x.answers.map((a) => ({
            questionId: x.questionId,
            answerId: a,
            skillId: this.skill.id,
          }));
        })
        .flat();
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isWorkSkills() {
      return this.skill.id == referralsAndEquipmentSkills.WorkSkills;
    },
  },
};
</script>
